// extracted by mini-css-extract-plugin
module.exports = {"title":"Support_title__32t6J"};